import i18next from 'i18next';

export function getTimeStamp(): number {
    return Math.floor(Date.now() / 1000);
}

export function getDateLabel(value: Date, hideTime: boolean = false): string {
    if (!hideTime) {
        return `${toLocaleDateString(value, i18next.language).replace(/&lrm;|\u200E/gi, '')} - ${value.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}`;
    }
    return toLocaleDateString(value, i18next.language).replace(/&lrm;|\u200E/gi, '');
}

/** uses en-gb for i18n.language === 'en' */
export function toLocaleDateString(value: Date, language: string): string {
    return value.toLocaleDateString(
        language === 'en' ? 'en-GB' : language,
        { day: '2-digit', month: '2-digit', year: 'numeric' }
    );
}

export function getDateTimePartForFilename(): string {
    const currentDate: Date = new Date();
    const minutes: number = currentDate.getMinutes();
    const currentTime: string = `${currentDate.getHours()}${minutes > 10 ? minutes : `0${minutes}`}`;
    return `${toLocaleDateString(currentDate, i18next.language)}-${currentTime}`.replace(/[^\w\-]/g, '_');
}